import { useEffect, useRef, useState } from "react";
import italy from "../img/about/Italy.JPG";
import berlin from "../img/about/Berlin.JPG";
import greece from "../img/about/Greece.JPG";
import cuneo from "../img/about/Cuneo.JPG";

const images = [italy, berlin, greece, cuneo];

export default function Carousel() {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  const delay = 4000;

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, delay);

    return () => {
      resetTimeout();
    };
  }, [current]);

  return (
    <div className="w-full overflow-x-hidden relative group">
      {/* Slides Container */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((src, index) => (
          <div
            key={index}
            className="flex-shrink-0 flex justify-center items-center w-full"
          >
            <img
              src={src}
              className="rounded-2xl"
              alt={`Slide ${index + 1}`}
              style={{ maxWidth: "60%", height: "auto" }}
            />
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-all ${
              current === index ? "bg-black" : "bg-gray-300"
            }`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}
